import { ITotalRecords } from './common.model';

export interface ITableDto extends ITotalRecords {
  id: number;
  restaurantId: number;
  outletId: number;
  customerId: number;
  customerName: string;
  customerEmail: string;
  customerMobile: string;
  requestDate: Date;
  requestTime: string;
  tableRequested: number;
  note: string;
  requestStatus: number;
  createdOn: Date;
}

export interface IKioskTableDto extends ITotalRecords {
  id: number;
  outletId: number;
  tableGuid: string;
  tableName: string;
  tableType: number;
  tableTypeName: string;
  isAvailable: boolean;
  isSync: boolean;
  isActive: boolean;
  tableUrl: string;
}

export interface IKioskBannerDto extends ITotalRecords {
  id: number;
  outletId: number;
  bannerText: string;
  bannerUrl: string;
  attachment: string;
  isActive: boolean;
}

// export interface ITableFeatureDto {
//   id: number;
//   isTableServices: boolean;
//   isTableEmail: boolean;
//   isTableMobile: boolean;
//   isTableEmailMand: boolean;
//   isTableMobileMand: boolean;
//   isKioskServices: boolean;
// }
